export default {
	events: {
		'ddc.wstagging.first': [
			{
				logic: {
					'DDC.dataLayer.page.pageInfo.isVdp': true
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.pageView]]'
					]
				},
				trigger: ['ecommerceVDP', 'vdpView']
			},
			{
				logic: {
					'DDC.dataLayer.page.pageInfo.isVlp': true
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.pageView]]'
					],
					vehicles_viewed:
						'[[window.DDC.dataLayer.vehicles.length]] >> {{UNDEFINED}}'
				}
			},
			{
				logic: {
					mustNotEqual: {
						'mapping.pagealias.page_type': '{{EMPTYSTRING}}'
					}
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.pageView]]'
					]
				}
			}
		],
		'vehicle-data-updated': [
			{
				payload: {
					event: 'view_item_list',
					ecommerce: {
						items: '[[fn.getVehicleImpressions]]'
					}
				}
			}
		],
		'ddc.inventory.filterSearch': [
			{
				logic: {
					'DDC.dataLayer.page.pageInfo.isVlp': true
				},
				payload: {
					event: 'vehicle_search'
				}
			}
		],
		'ddc.inventory.filterSearch.click': [
			{
				logic: {
					clickedFacetName: 'compositeType'
				},
				payload: {
					event: 'vlp_filtering',
					filter_category: 'type',
					filter_value: '[[eventData.clickedFacetValue]]'
				}
			},
			{
				payload: {
					event: 'vlp_filtering',
					filter_category: ({
						eventData: { clickedFacetName } = {}
					}) => {
						return clickedFacetName === 'normalModel'
							? 'model'
							: clickedFacetName;
					},
					filter_value: '[[eventData.clickedFacetValue]]'
				}
			}
		],
		'ddc.form.confirmation': [
			{
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.formConfirmation]]'
					]
				}
			}
		],
		widgetUserEvent: [
			{
				logic: {
					action: 'changed',
					element: 'Payment Type',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_payment_calculator',
					event: 'drs'
				},
				trigger: 'drstart'
			},
			{
				logic: {
					action: 'changed',
					element: 'Payment Term',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_payment_calculator',
					event: 'drs'
				},
				trigger: 'drstart'
			},
			{
				logic: {
					action: 'changed',
					element: 'Credit Tier',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_payment_calculator',
					event: 'drs'
				},
				trigger: 'drstart'
			},
			{
				logic: {
					action: 'changed',
					element: 'Down Payment',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_payment_calculator',
					event: 'drs'
				},
				trigger: 'drstart'
			},
			{
				logic: {
					action: 'changed',
					element: 'Offer Price',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_payment_calculator',
					event: 'drs'
				},
				trigger: 'drstart'
			},
			{
				logic: {
					action: 'changed',
					element: 'Lease Annual Miles',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_payment_calculator',
					event: 'drs'
				},
				trigger: 'drstart'
			},
			{
				logic: {
					action: 'displayed',
					element: 'Credit App Success',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_credit_application',
					event: 'drs'
				},
				trigger: ['drstart', 'drcreditformsubmit']
			},
			{
				logic: {
					action: 'displayed',
					element: 'Tradein Estimate',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_trade_in',
					event: 'drs'
				},
				trigger: 'drstart'
			},
			{
				logic: {
					action: 'received',
					element: 'Tradein Estimate',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					event: 'form_submitted',
					hform: 'drs_sales_tradein',
					formclass: 'sales'
				},
				trigger: 'drstart'
			},
			{
				logic: {
					action: 'requested',
					element: 'Test Drive',
					widgetName: 'digital-retailing-cox'
				},
				payload: {
					drs_type: 'drs_test_drive',
					event: 'drs'
				},
				trigger: ['drstart', 'drtestdriverequested']
			}
		]
	},
	triggerEvents: {
		drstart: {
			configuration: {
				count: 1,
				when: 'first'
			},
			logic: {
				mustNotEqual: {
					'eventData.action': 'display'
				}
			},
			payload: {
				drs_type: 'drs_start',
				event: 'drs'
			}
		},
		drcreditformsubmit: {
			payload: {
				event: 'form_submitted',
				hform: 'drs_sales_fullcredit',
				formclass: 'sales'
			}
		},
		drtestdriverequested: {
			payload: {
				event: 'form_submitted',
				hform: 'drs_sales_testdrive',
				formclass: 'sales'
			}
		},
		ecommerceVLP: {
			payload: {
				event: 'view_item_list',
				ecommerce: {
					items: '[[fn.getVehicleImpressions]]'
				}
			}
		},
		vdpView: {
			logic: {
				'DDC.dataLayer.page.pageInfo.isVdp': true
			},
			payload: {
				event: 'vdp_view'
			}
		},
		ecommerceVDP: {
			logic: {
				'DDC.dataLayer.page.pageInfo.isVdp': true
			},
			payload: {
				event: 'view_item',
				ecommerce: {
					items: '[[fn.getVehicleImpressions]]'
				}
			}
		}
	},
	fireGroups: {
		drstart: {
			maxCount: 1
		}
	}
};
